// Every date on the site is shown in New York time, server and client alike.
const TIME_ZONE = "America/New_York";
// "ET" is right all year; New York switches between EST and EDT.
const TIME_ZONE_LABEL = "ET";

export const formatDate = (
  dateString: string,
  opts?: { includeYear?: boolean; dateOnly?: boolean }
): string => {
  const date = new Date(dateString);

  if (opts?.dateOnly) {
    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "numeric",
      year: opts?.includeYear ? "numeric" : undefined,
      timeZone: TIME_ZONE,
    };
    return date.toLocaleDateString("en-US", options);
  }

  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    year: opts?.includeYear ? "numeric" : undefined,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: TIME_ZONE,
  };
  const formatted = date.toLocaleString("en-US", options);
  return `${formatted} ${TIME_ZONE_LABEL}`;
};

export const formatDayKey = (dateString: string): string =>
  new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: TIME_ZONE,
  });
